import { useNavigate } from "react-router-dom";
import { MoreVertical, Pencil, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { useState } from "react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const BookSwitcher = ({ books, current, onRename }) => {
  const nav = useNavigate();
  const [confirm, setConfirm] = useState(false);
  const { can } = useAuth();

  const del = async () => {
    try {
      await api.delete(`/books/${current.id}`);
      toast.success("Book deleted");
      nav("/");
    } catch (ex) {
      toast.error(errMsg(ex));
    }
  };

  return (
    <>
      <Select value={current?.id} onValueChange={(v) => nav(`/book/${v}`)}>
        <SelectTrigger data-testid="book-switcher-select" className="rounded-none h-9 min-w-0 w-auto max-w-full sm:max-w-xs [&>span]:truncate border-slate-400 bg-white font-extrabold uppercase tracking-tight">
          <SelectValue placeholder="Select book" />
        </SelectTrigger>
        <SelectContent className="rounded-none">
          {books.map((b) => (
            <SelectItem key={b.id} value={b.id} data-testid={`book-option-${b.id}`} className="uppercase font-semibold">{b.name}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      {can("books") && <DropdownMenu>
        <DropdownMenuTrigger data-testid="book-menu-btn" className="h-9 w-9 shrink-0 grid place-items-center hover:bg-slate-200 transition-colors">
          <MoreVertical size={16} />
        </DropdownMenuTrigger>
        <DropdownMenuContent className="rounded-none" align="start">
          <DropdownMenuItem data-testid="rename-book-btn" onSelect={onRename}><Pencil size={14} className="mr-2" /> Rename / balances</DropdownMenuItem>
          <DropdownMenuItem data-testid="delete-book-btn" onSelect={() => setConfirm(true)} className="text-red-700"><Trash2 size={14} className="mr-2" /> Delete book</DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>}
      <AlertDialog open={confirm} onOpenChange={setConfirm}>
        <AlertDialogContent className="rounded-none">
          <AlertDialogHeader>
            <AlertDialogTitle>Delete “{current?.name}”?</AlertDialogTitle>
            <AlertDialogDescription>This removes the book and all its entries. It can’t be undone.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel className="rounded-none">Cancel</AlertDialogCancel>
            <AlertDialogAction data-testid="delete-book-confirm" onClick={del} className="rounded-none bg-red-700 hover:bg-red-800">Delete</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
